import { render } from "./MainProduct.vue?vue&type=template&id=6c2f8c62"
import script from "./MainProduct.vue?vue&type=script&lang=js"
export * from "./MainProduct.vue?vue&type=script&lang=js"

import "./MainProduct.vue?vue&type=style&index=0&id=6c2f8c62&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__